<div class="chat-message-list">
  <button
    *ngIf="hasMoreBefore"
    class="chat-message-list__load-more"
    type="button"
    [disabled]="isLoadingBefore"
    (click)="onLoadMoreBefore()"
  >
    <span class="chat-message-list__load-more-body">Загрузить ещё</span>
  </button>
  <chat-message
    *ngFor="let message of messages; trackBy: trackByMessageId"
    [message]="message"
    [template]="template"
  ></chat-message>
  <button
    *ngIf="hasMoreAfter"
    class="chat-message-list__load-more"
    type="button"
    [disabled]="isLoadingAfter"
    (click)="onLoadMoreAfter()"
  >
    <span class="chat-message-list__load-more-body">Загрузить предыдущие</span>
  </button>
  <chat-activity *ngIf="activity" [activity]="activity"></chat-activity>
</div>
